import React from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'

// components
import { Guide } from './Guide'

const Intro = styled.div`
	line-height: 1.5;
`

Guides.propTypes = {
	guides: array,
	intro: string,
}

/**
 * Short section of the SEO page that displays a series of "downloadable guide" cards, rendered in <Guide />
 */
export function Guides({ guides, intro }) {
	return (
		<>
			{intro && <Intro dangerouslySetInnerHTML={{ __html: intro }} />}
			{guides && guides.map((guide) => <Guide {...guide} key={guide.id} />)}
		</>
	)
}
